/* ==========================================================================
   Slime Lab page — sections/main-page-slime-lab.liquid
   --------------------------------------------------------------------------
   Four independent behaviours, each of which no-ops when its markup is absent
   so the merchant can empty any rail in the customizer without breaking JS:

     1. Hero button smooth-scroll (only when no link was set)
     2. Slime TV topic filter
     3. Symptom tiles -> diagnosis panel (a real tablist)
     4. Video lightbox

   Re-initialises on shopify:section:load so the theme editor stays live.
   ========================================================================== */
(function () {
  'use strict';

  var SEL = '[data-slab]';

  function init(root) {
    if (!root || root.dataset.slabReady === '1') return;
    root.dataset.slabReady = '1';

    initScroll(root);
    initFilters(root);
    initDiagnosis(root);
    initModal(root);
  }

  /* ---------------------------------------------------------------- 1. */
  function initScroll(root) {
    root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-slab-scroll]');
      if (!trigger) return;
      var target = root.querySelector(trigger.getAttribute('data-slab-scroll'));
      if (!target) return;
      e.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* ---------------------------------------------------------------- 2. */
  function initFilters(root) {
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-slab-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-slab-video-card]'));
    var empty = root.querySelector('[data-slab-video-empty]');
    if (!chips.length || !cards.length) return;

    function apply(key) {
      var shown = 0;
      cards.forEach(function (card) {
        var cats = (card.getAttribute('data-cats') || '').split(/\s+/);
        var match = key === 'all' || cats.indexOf(key) !== -1;
        card.hidden = !match;
        if (match) shown++;
      });
      if (empty) empty.hidden = shown !== 0;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (other) {
          var on = other === chip;
          other.classList.toggle('is-active', on);
          other.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply(chip.getAttribute('data-slab-filter'));
      });
    });
  }

  /* ---------------------------------------------------------------- 3. */
  function initDiagnosis(root) {
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-slab-tile]'));
    var panel = root.querySelector('[data-slab-diag]');
    if (!tiles.length || !panel) return;

    var elTitle = panel.querySelector('[data-diag-out-title]');
    var elSub = panel.querySelector('[data-diag-out-sub]');
    var elSteps = panel.querySelector('[data-diag-out-steps]');
    var elLink = panel.querySelector('[data-diag-out-link]');
    var elNote = root.querySelector('[data-diag-out-note]');

    function select(tile, focus) {
      tiles.forEach(function (other) {
        var on = other === tile;
        other.classList.toggle('is-active', on);
        other.setAttribute('aria-selected', on ? 'true' : 'false');
        other.setAttribute('tabindex', on ? '0' : '-1');
      });

      if (elTitle) elTitle.textContent = tile.getAttribute('data-diag-title') || '';
      if (elSub) elSub.textContent = tile.getAttribute('data-diag-sub') || '';
      if (elNote) elNote.textContent = tile.getAttribute('data-diag-note') || '';
      if (elLink) elLink.setAttribute('href', tile.getAttribute('data-diag-link') || '#');

      if (elSteps) {
        var steps = (tile.getAttribute('data-diag-steps') || '')
          .split('|')
          .map(function (s) { return s.trim(); })
          .filter(Boolean);
        elSteps.textContent = '';
        steps.forEach(function (step) {
          var li = document.createElement('li');
          var dot = document.createElement('span');
          dot.className = 'slab-diag__bullet';
          dot.setAttribute('aria-hidden', 'true');
          li.appendChild(dot);
          li.appendChild(document.createTextNode(step));
          elSteps.appendChild(li);
        });
      }

      panel.setAttribute('aria-labelledby', tile.id);
      if (focus) tile.focus();
    }

    tiles.forEach(function (tile, i) {
      tile.addEventListener('click', function () { select(tile, false); });
      tile.addEventListener('keydown', function (e) {
        var step = 0;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') step = 1;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') step = -1;
        else if (e.key === 'Home') { e.preventDefault(); select(tiles[0], true); return; }
        else if (e.key === 'End') { e.preventDefault(); select(tiles[tiles.length - 1], true); return; }
        if (!step) return;
        e.preventDefault();
        select(tiles[(i + step + tiles.length) % tiles.length], true);
      });
    });
  }

  /* ---------------------------------------------------------------- 4. */
  function initModal(root) {
    var modal = root.querySelector('[data-slab-modal]');
    if (!modal) return;
    var video = modal.querySelector('[data-slab-modal-video]');
    var lastFocus = null;

    function open(src, title) {
      lastFocus = document.activeElement;
      if (video) {
        video.setAttribute('src', src);
        if (title) video.setAttribute('aria-label', title);
      }
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      // The backdrop carries data-slab-modal-close too, so the button has to be
      // selected by tag — a bare attribute query lands on the unfocusable div.
      // The browser also focuses the clicked link after this handler returns,
      // so the dialog claims focus on the next frame to keep it.
      var closeBtn = modal.querySelector('button[data-slab-modal-close]');
      if (closeBtn) {
        window.requestAnimationFrame(function () { closeBtn.focus(); });
      }
      if (video && video.play) {
        var p = video.play();
        if (p && p.catch) p.catch(function () { /* autoplay blocked — the controls are there */ });
      }
    }

    // Keep Tab inside the dialog while it is open.
    function trap(e) {
      if (e.key !== 'Tab' || modal.hidden) return;
      var focusable = modal.querySelectorAll('button, [href], video[controls], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (!modal.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      }
    }

    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-slab-play]');
      if (trigger) {
        var src = trigger.getAttribute('data-slab-play');
        if (src) {
          e.preventDefault();
          open(src, trigger.getAttribute('data-slab-title'));
        }
        return;
      }
      if (e.target.closest('[data-slab-modal-close]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
      else trap(e);
    });
  }

  function boot(scope) {
    var nodes = (scope || document).querySelectorAll(SEL);
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
